import { memo, type ReactNode } from 'react'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'

import type { BillingInterval } from './billing.interface'

export interface BillingIntervalToggleProps {
  billingInterval: BillingInterval
  onChange?: (interval: BillingInterval) => void
  isDisabled?: boolean
  id?: string
  className?: string
}

const BillingIntervalToggleBase: React.FC<BillingIntervalToggleProps> = ({
  billingInterval,
  onChange,
  isDisabled = false,
  id = 'billing-interval',
  className,
}): ReactNode => {
  const handleToggle = (isYearly: boolean): void => {
    onChange?.(isYearly ? 'yearly' : 'monthly')
  }

  return (
    <div className={cn('billing-interval-toggle flex items-center gap-2', className)}>
      <Label htmlFor={id} className="text-sm text-muted-foreground">
        Monthly
      </Label>
      <Switch
        id={id}
        checked={billingInterval === 'yearly'}
        onCheckedChange={handleToggle}
        disabled={isDisabled}
      />
      <Label htmlFor={id} className="text-sm text-muted-foreground">
        Yearly
      </Label>
    </div>
  )
}

export const BillingIntervalToggle = memo(BillingIntervalToggleBase)

BillingIntervalToggle.displayName = 'BillingIntervalToggle'
